import * as palette from "@govlaunch/palette";
import { omit } from "lodash/fp";
import React from "react";
import { Field } from "react-final-form";
import TextareaAutosize from "react-textarea-autosize";
import CharacterLimitIndicator from "~/components/form/CharacterLimitIndicator";
import FieldValidationError from "~/components/form/FieldValidationError";
import { IFormFieldProps } from "~/components/form/FormFieldProps";

export default function TextareaField({
  fieldName,
  label,
  placeholder,
  characterLimit,
  showCharacterCount,
  ariaLabel,
  ...props
}: IFormFieldProps) {
  return (
    <Field name={fieldName}>
      {({ input, meta }) => (
        <div>
          <div
            css={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {label && (
              <label
                css={{
                  fontWeight: 500,
                  fontSize: 14,
                  color: palette.mediumGray,
                  margin: 0,
                }}
              >
                {label}
              </label>
            )}

            <FieldValidationError meta={meta} />
          </div>

          <TextareaAutosize
            css={{
              marginTop: label ? 8 : 0,
              "::placeholder": {
                color: palette.sealBlue,
              },
              ":focus": {
                borderColor: palette.primary,
              },
              fontSize: 14,
              border: `1px solid ${palette.lightestGray}`,
              borderRadius: 5,
              padding: "10px 10px",
              width: "100%",
              outline: 0,
              resize: "none",
            }}
            maxLength={characterLimit}
            minRows={2}
            maxRows={6}
            aria-label={ariaLabel || placeholder || ""}
            placeholder={placeholder}
            {...omit(["onFocus"], input)}
            {...props}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          />

          {characterLimit && showCharacterCount && (
            <div
              css={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: 8,
              }}
            >
              <CharacterLimitIndicator
                maxLength={characterLimit}
                description={input.value}
                css={{
                  marginLeft: "auto",
                }}
              />
            </div>
          )}
        </div>
      )}
    </Field>
  );
}
